import { render, staticRenderFns } from "./Examinationjg.vue?vue&type=template&id=30601889&scoped=true"
import script from "./Examinationjg.vue?vue&type=script&lang=js"
export * from "./Examinationjg.vue?vue&type=script&lang=js"
import style0 from "./Examinationjg.vue?vue&type=style&index=0&id=30601889&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30601889",
  null
  
)

export default component.exports